import { ApiGameCategoriesService } from "../../services/api-game-categories.service";
import { patchState, signalStore, withHooks, withMethods, withState } from "@ngrx/signals";
import { setAllEntities, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { GameCategoryViewModel } from "@playcharge/common/models/backend/offers/game-category-view-model";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";

export type GameCategoriesStore = InstanceType<typeof GameCategoriesStore>;

export const GameCategoriesStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<GameCategoryViewModel>(),
    withRequestStatus(),
    withMethods((store, apiGameCategoriesService = inject(ApiGameCategoriesService)) => ({
        loadCategories: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiGameCategoriesService.getAll().pipe(
                        tap((categories) => {
                            patchState(store, setAllEntities(categories));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadCategories();
        },
    })),
);
